import { FilterRemove } from "iconsax-react";
import EventListCards from "../EventListCards";
import FilterTextInput from "../FilterTextInput";
import { motion as m } from "framer-motion";
import Paginator from "../Paginator";

const EventListTable = ({
  eventList,
  eventMeta,
  handleRecordClick,
  handlePageClick,
  perPage,
  handlePerPageChange,
  searchTerm,
  handleSearch,
  handleKeyDown,
  clearFilter,
}) => {
  return (
    <m.div
      className="flex flex-col border border-[#EFF0F2] w-full h-fit bg-white rounded-xl"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Filters */}
      <div className="flex w-full border-b border-[#EFF0F2] px-[24px] py-[12px] gap-[8px] items-center justify-end">
        {clearFilter && searchTerm !== "" && (
          <FilterRemove
            size="16"
            onClick={clearFilter}
            variant="Bold"
            className="text-[#FF3030] hover:cursor-pointer hover:text-[#5C4BF5]"
          />
        )}
        <FilterTextInput
          value={searchTerm}
          onChange={handleSearch}
          onKeyDown={handleKeyDown}
        />
      </div>

      {/* Event data */}
      <div className="flex flex-wrap w-full h-full px-[24px] py-[12px] gap-[24px] items-center justify-center">
        {eventList.length === 0 ? (
          <div className="flex w-full h-[290px] items-center justify-center text-gray-500 text-[25px]">
            No events available
          </div>
        ) : (
          eventList.map((event, index) => (
            <EventListCards
              key={index}
              id={event.id}
              imageSource={event.image}
              title={event.name}
              date={event.date}
              onClick={handleRecordClick}
            />
          ))
        )}
      </div>

      {/* Pagination */}
      {eventMeta && (
        <Paginator
          handlePageClick={handlePageClick}
          meta={eventMeta}
          perPage={perPage}
          handlePerPageChange={handlePerPageChange}
        />
      )}
    </m.div>
  );
};

export default EventListTable;
